export function familyChildrenPath() {
  return '/family/children'
}
